<template>
    <div class="c-o-request-section c-o-request-section--information">
        <div
            class="c-o-request-section__inner c-o-request-section__inner--offset-left"
        >
            <div
                class="c-o-request-section__main c-o-request-section__main--small"
            >
                <h2 class="c-o-request-section__title h2">
                    Uppdragsinformation
                </h2>
                <ul class="c-o-request-section__details">
                    <li v-if="request.Id" class="c-o-request-section__detail">
                        <span class="c-o-request-section__detail-title"
                            >Projektnr</span
                        >
                        {{ request.Id }}
                    </li>
                    <li
                        v-if="request.Category && request.Category.Name"
                        class="c-o-request-section__detail"
                    >
                        <span class="c-o-request-section__detail-title"
                            >Kategori</span
                        >
                        {{ request.Category.Name }}
                    </li>
                    <li
                        v-if="request.Address"
                        class="c-o-request-section__detail"
                    >
                        <span class="c-o-request-section__detail-title"
                            >Projektets adress</span
                        >
                        {{ request.Address }}
                    </li>
                    <li
                        v-if="request.Region && request.Region.Name"
                        class="c-o-request-section__detail"
                    >
                        <span class="c-o-request-section__detail-title"
                            >Kommun (objekt)</span
                        >
                        {{ request.Region.Name }}
                    </li>
                    <li
                        v-if="request.StartTime && request.StartTime.Name"
                        class="c-o-request-section__detail"
                    >
                        <span class="c-o-request-section__detail-title"
                            >Starttidpunkt</span
                        >
                        {{ request.StartTime.Name }}
                    </li>
                    <li
                        v-if="request.ClientType && request.ClientType.Name"
                        class="c-o-request-section__detail"
                    >
                        <span class="c-o-request-section__detail-title"
                            >Uppdragsgivare</span
                        >
                        {{ request.ClientType.Name }}
                    </li>
                    <li
                        v-if="request.Fields"
                        v-for="(value, key) in request.Fields"
                        :key="key"
                        class="c-o-request-section__detail"
                    >
                        <span class="c-o-request-section__detail-title">{{
                            key
                        }}</span>
                        {{ value }}
                    </li>
                </ul>
                <span
                    v-if="request.OtherInformation"
                    class="c-o-request-section__detail-title"
                    >Övriga upplysningar</span
                >
                <p
                    v-if="request.OtherInformation"
                    class="c-o-request-section__body"
                >
                    {{ request.OtherInformation }}
                </p>
            </div>
            <div class="c-o-request-section__sidebar">
                <!-- If no data is loading, there are no errors and the user is allowed to answer or already has answered... -->
                <div
                    v-if="
                        !loading &&
                            !error &&
                            ((answerInfo && answerInfo.CanAnswer) ||
                                (answerInfo && answerInfo.HasAnswered)) &&
                            request.AnswerCount < 6
                    "
                    class="c-o-request-section__diploma"
                >
                    <span class="c-o-request-section__diploma-badge">
                        <icon :icon="'location_city'"></icon>
                    </span>
                    <div v-if="request.AnswerCount < 6">
                        <p class="c-o-request-section__diploma-highlight h3">
                            {{ request.AnswerCount }} st
                        </p>
                        <p class="c-o-request-section__diploma-label">
                            företag har besvarat förfrågan
                        </p>
                        <p
                            class="c-o-request-section__diploma-info"
                            v-if="answerInfo.HasAnswered"
                        >
                            Du har besvarat denna förfrågan den
                            {{ request.AnswerDate }}
                        </p>
                        <p class="c-o-request-section__diploma-info" v-else>
                            Besvara bara de förfrågningar du verkligen är
                            intresserad av.
                        </p>
                    </div>
                    <div v-else>
                        <p class="c-o-request-section__diploma-info">
                            Den här förfrågan är fullbesvarad
                        </p>
                        <p
                            class="c-o-request-section__diploma-info"
                            v-if="answerInfo.HasAnswered"
                        >
                            Du har besvarat denna förfrågan den
                            {{ request.AnswerDate }}
                        </p>
                    </div>
                     <atom-button
                        class="c-o-request-section__diploma-button c-a-button--theme-primary"
                        v-if="answerInfo.HasAnswered"
                        :label="'Läs ditt svar'"
                        v-tooltip="
                            'Klicka på knappen för att läsa ditt svar till kund.'
                        "
                        @buttonClicked="showAnswerModal = true"
                    ></atom-button>
                    <atom-button
                        class="c-o-request-section__diploma-button c-a-button--theme-primary"
                        v-else
                        :label="'Besvara förfrågan'"
                        @buttonClicked="showModal = true"
                    ></atom-button>
                    <p
                        class="c-o-request-section__diploma-info"
                        v-if="!answerInfo.HasAnswered"
                    >
                        Kostnad: 1 kundkontakt, du har {{ contactBalance }} st
                        kvar.
                    </p>
                </div>
                <!-- If no data is loading, there are no errors and the user is a company user (e.g. answerInfo is available)... -->
                <div
                    v-else-if="
                        !loading && !error && answerInfo && isCompanyUser
                    "
                    class="c-o-request-section__diploma"
                >
                    <span class="c-o-request-section__diploma-badge">
                        <icon :icon="'location_city'"></icon>
                    </span>
                    <div v-if="request.AnswerCount < 6">
                        <p class="c-o-request-section__diploma-highlight h3">
                            {{ request.AnswerCount }} st
                        </p>
                        <p class="c-o-request-section__diploma-label">
                            företag har besvarat förfrågan
                        </p>
                        <p class="c-o-request-section__diploma-info">
                            <b
                                >Den här förfrågan är inte öppen för dig att
                                besvara.</b
                            >
                        </p>
                    </div>
                    <div v-else>
                        <p class="c-o-request-section__diploma-info">
                            Den här förfrågan är fullbesvarad
                        </p>
                    </div>
                    <atom-button
                        v-if="answerInfo.HasAnswered"
                        class="c-o-request-section__diploma-button c-a-button--theme-primary"
                        :label="'Läs ditt svar'"
                        v-tooltip="
                            'Klicka på knappen för att läsa ditt svar till kund.'
                        "
                        @buttonClicked="showAnswerModal = true"
                    ></atom-button>
                    <atom-button
                        v-else
                        class="c-o-request-section__diploma-button c-a-button--theme-primary"
                        :label="'Besvara'"
                        v-tooltip="
                            'Du har inte tillåtelse att besvara den här förfrågan'
                        "
                        :disabled="true"
                    ></atom-button>
                    <p class="c-o-request-section__diploma-info">
                        Du har {{ contactBalance }} st kundkontakter kvar.
                    </p>
                </div>
                <!-- Default output for unauthenticated casuals :( -->
                <div v-else class="c-o-request-section__diploma">
                    <span class="c-o-request-section__diploma-badge">
                        <icon :icon="'location_city'"></icon>
                    </span>
                    <div v-if="request.AnswerCount < 6">
                        <p class="c-o-request-section__diploma-highlight h3">
                            {{ request.AnswerCount }} st
                        </p>
                        <p class="c-o-request-section__diploma-label">
                            företag har besvarat förfrågan
                        </p>
                    </div>
                    <div v-else>
                        <p class="c-o-request-section__diploma-info">
                            Den här förfrågan är fullbesvarad
                        </p>
                    </div>
                </div>

                <div
                    v-if="
                        !loading &&
                            !error &&
                            answerInfo &&
                            answerInfo.HasAnswered
                    "
                    class="c-o-request-section__diploma c-o-request-section__diploma--left o-wysiwyg"
                >
                    <span class="c-o-request-section__diploma-badge">
                        <icon :icon="'phone'"></icon>
                    </span>
                    <p class="c-o-request-section__diploma-label">Namn</p>
                    <p class="">{{ request.User.Name }}</p>
                    <p class="c-o-request-section__diploma-label">Telefon</p>
                    <p class="">
                        <a :href="'tel:' + request.User.Phone">{{
                            request.User.Phone
                        }}</a>
                    </p>
                    <p class="c-o-request-section__diploma-label">E-post</p>
                    <p class="">
                        <a :href="'mailto:' + request.User.Email">{{
                            request.User.Email
                        }}</a>
                    </p>
                    <p class="c-o-request-section__diploma-label">
                        Projektets adress
                    </p>
                    <p class="">{{ request.User.Address }}</p>
                    <p class="">{{ request.User.City }}</p>
                </div>
            </div>
            <modal
                class="c-m-modal--small"
                v-if="showAnswerModal"
                @close="showAnswerModal = false"
            >
                <p class="c-m-modal--small__preline">{{ request.Answer }}</p>
                <button-group>
                    <atom-button
                        :class="'c-a-button--theme-gray'"
                        :label="'Stäng'"
                        @buttonClicked="showAnswerModal = false"
                    ></atom-button>
                </button-group>
            </modal>
            <modal
                class="c-m-modal--small"
                v-if="showModal"
                @close="showModal = false"
            >
                <h1>Besvara förfrågan</h1>
                <p>
                    Om du besvarar förfrågan så skickas automatiskt ett mail
                    till kunden och du får då även tillgång till kundens
                    kontaktuppgifter. Nedan finns ett standardsvar du kan utgå
                    ifrån.
                </p>
                <select
                    @change="onTemplateSelect"
                    class="c-o-my-pages-section__form u-padding-1 u-margin-bottom-1"
                    v-model="selectedMailTemplate"
                    :disabled="!mailTemplates.length"
                >
                    <option value="">{{
                        !mailTemplates.length
                            ? "Du har inga svar sparade"
                            : " Välj svar"
                    }}</option>
                    <option
                        v-for="(response, index) in mailTemplates"
                        :key="index"
                        :value="response.Subject"
                        >{{ response.Subject }}
                    </option>
                </select>
                <atom-textarea
                    :id="`answer-request-${request.Id}-textarea`"
                    :label="'Meddelande'"
                    :rows="10"
                    v-model="answerMessage"
                >
                </atom-textarea>
                <button-group>
                    <success-button
                        :currentState="sendStatus"
                        :customStates="answerButtonStates"
                        @buttonClicked="send"
                    >
                    </success-button>
                    <atom-button
                        :class="'c-a-button--theme-gray'"
                        :label="'Avbryt'"
                        @buttonClicked="showModal = false"
                    ></atom-button>
                </button-group>
            </modal>
        </div>
    </div>
</template>

<script>
import AtomButton from "../../atoms/AtomButton.vue";
import Icon from "../../atoms/AtomIcon.vue";
import SuccessButton from "../../atoms/AtomSuccessButton.vue";
import AtomTextarea from "../../atoms/form/AtomTextarea.vue";
import ButtonGroup from "../../molecules/MoleculeButtonGroup.vue";
import Carousel from "../../molecules/MoleculeCarousel.vue";
import Modal from "../../molecules/MoleculeModal.vue";
import Map from "./OrganismRequestMap.vue";

import { mapActions, mapGetters, mapMutations } from "vuex";
import { IS_COMPANY } from "../../../../store/store-models/authentication-model.js";
import { GET_COMPANY_MAIL_TEMPLATES } from "../../../../store/store-models/my-pages-company-model";
import {
    GET_ANSWER_INFO,
    GET_ERROR,
    GET_MESSAGE,
    GET_SEND_ERROR,
    INCREMENT_ANSWER_COUNT,
    IS_LOADING,
    SEND_ANSWER,
    SET_MESSAGE
} from "../../../../store/store-models/request-model.js";

import Filters from "../../../../filters/index.js";
import { timeout } from "../../../../helpers";

export default {
    components: {
        Icon,
        AtomButton,
        AtomTextarea,
        SuccessButton,
        Carousel,
        Modal,
        ButtonGroup,
        Map
    },
    filters: Filters,
    props: ["request"],
    data() {
        return {
            sendStatus: "default",
            showModal: false,
            showAnswerModal: false,
            selectedMailTemplate: "",
            mailTemplates: []
        };
    },
    created() {
        this.getMailTemplates().then(({ data }) => {
            if (data.length) {
                this.mailTemplates = data;
            } else {
                this.mailTemplates = [];
            }
        });
    },
    computed: {
        ...mapGetters({
            answerInfo: GET_ANSWER_INFO,
            message: GET_MESSAGE,
            sendError: GET_SEND_ERROR,
            isCompanyUser: IS_COMPANY
        }),
        answerMessage: {
            get() {
                return this.message;
            },
            set(val) {
                this.$store.commit(SET_MESSAGE, val);
            }
        },
        loading: function() {
            return this.$store.getters[IS_LOADING]("requestAnswer");
        },
        error: function() {
            return this.$store.getters[GET_ERROR]("requestAnswer");
        },
        answerButtonStates: function() {
            return {
                default: {
                    label: "Skicka"
                },
                processing: {
                    label: "Skickar"
                },
                success: {
                    label: "Skickat!"
                }
            };
        },
        contactBalance: function() {
            return this.answerInfo.ContactBalance
                ? this.answerInfo.ContactBalance
                : 0;
        }
    },
    methods: {
        ...mapActions({
            sendAnswer: SEND_ANSWER,
            getMailTemplates: GET_COMPANY_MAIL_TEMPLATES
        }),
        ...mapMutations({
            incrementAnswerCount: INCREMENT_ANSWER_COUNT
        }),
        async send() {
            try {
                this.sendStatus = "processing";
                const result = await this.sendAnswer(this.request.Id);
                this.answerInfo.HasAnswered = true;
                this.sendStatus = "success";
                this.incrementAnswerCount();
                await timeout();
                this.sendStatus = "default";
                this.showModal = false;
                this.showAnswerModal = false;
            } catch (e) {
                if (this.sendError) {
                    this.sendStatus = "error";
                    await timeout();
                    this.sendStatus = "default";
                }
            }
        },
        onTemplateSelect() {
            const selectedTemplate = this.mailTemplates.find(
                m => m.Subject === this.selectedMailTemplate
            );
            if (selectedTemplate) {
                this.answerMessage = selectedTemplate.Body;
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/request-sections/OrganismRequestSectionInformation.vue